import { useCallback, useEffect, useState } from 'react';

import client from '../api/client';

// CRUD for the authenticated user's addresses (/api/address).
// Addresses carry a `type` of 'shipping' | 'billing'; callers filter as needed.
export default function useAddresses() {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    const { data } = await client.get('/address');
    setAddresses(Array.isArray(data) ? data : []);
  }, []);

  useEffect(() => {
    let active = true;
    setLoading(true);
    client
      .get('/address')
      .then(({ data }) => {
        if (active) setAddresses(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (active) setAddresses([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  const create = useCallback(
    async (body) => {
      const { data } = await client.post('/address', body);
      await reload();
      return data;
    },
    [reload]
  );

  const remove = useCallback(
    async (id) => {
      await client.delete(`/address/${id}`);
      await reload();
    },
    [reload]
  );

  return { addresses, loading, reload, create, remove };
}
